import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArtTrackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"art_track"}/>
}
